module.exports = __webpack_public_path__ + "media/images/flags/1x1/gum-1a61a24c493c8a7e0af439407b17818e.svg";